/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ClientDecision } from './ClientDecision';
import {
    ClientDecisionFromJSON,
    ClientDecisionFromJSONTyped,
    ClientDecisionToJSON,
} from './ClientDecision';
import type { ReengagePreviewResponse } from './ReengagePreviewResponse';
import {
    ReengagePreviewResponseFromJSON,
    ReengagePreviewResponseFromJSONTyped,
    ReengagePreviewResponseToJSON,
} from './ReengagePreviewResponse';
import type { TitleClearanceStatus } from './TitleClearanceStatus';
import {
    TitleClearanceStatusFromJSON,
    TitleClearanceStatusFromJSONTyped,
    TitleClearanceStatusToJSON,
} from './TitleClearanceStatus';
import type { TransactionEmailOutcomeResponse } from './TransactionEmailOutcomeResponse';
import {
    TransactionEmailOutcomeResponseFromJSON,
    TransactionEmailOutcomeResponseFromJSONTyped,
    TransactionEmailOutcomeResponseToJSON,
} from './TransactionEmailOutcomeResponse';
import type { TransactionTermsResponse } from './TransactionTermsResponse';
import {
    TransactionTermsResponseFromJSON,
    TransactionTermsResponseFromJSONTyped,
    TransactionTermsResponseToJSON,
} from './TransactionTermsResponse';
import type { TransactionTurn } from './TransactionTurn';
import {
    TransactionTurnFromJSON,
    TransactionTurnFromJSONTyped,
    TransactionTurnToJSON,
} from './TransactionTurn';
import type { UndoPreviewResponse } from './UndoPreviewResponse';
import {
    UndoPreviewResponseFromJSON,
    UndoPreviewResponseFromJSONTyped,
    UndoPreviewResponseToJSON,
} from './UndoPreviewResponse';

/**
 * 
 * @export
 * @interface TransactionResponse
 */
export interface TransactionResponse {
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    dispositionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    acquisitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    side: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    metaLabel?: string;
    /**
     * 
     * @type {TransactionTurn}
     * @memberof TransactionResponse
     */
    turn?: TransactionTurn;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    turnLabel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerRepresentation?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerAgentFullName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerAgentEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerAgentPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerAgentBrokerage?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerAgentLicenseNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    receivedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    offerSource?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    statusReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    isBackup: boolean;
    /**
     * 
     * @type {TransactionTermsResponse}
     * @memberof TransactionResponse
     */
    currentTerms?: TransactionTermsResponse;
    /**
     * 
     * @type {TransactionTermsResponse}
     * @memberof TransactionResponse
     */
    originalTerms?: TransactionTermsResponse;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof TransactionResponse
     */
    signatureState?: { [key: string]: string; };
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    finalWalkthroughScheduledAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    wireInstructionsReceivedAt?: Date;
    /**
     * 
     * @type {TitleClearanceStatus}
     * @memberof TransactionResponse
     */
    titleClearanceStatus?: TitleClearanceStatus;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    titleClearedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    closingRepairsCompleted?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    hazardInsuranceReceivedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    pinnedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    isRecommended?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    duplicateOfTransactionId?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    addressStr?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    partnerEntityName?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    noteForSeller?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    additionalComments?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    reengagedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    acceptedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    actualCloseDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    canTerminate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    canEditBindingDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    canCounter?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    canWithdraw?: boolean;
    /**
     * 
     * @type {UndoPreviewResponse}
     * @memberof TransactionResponse
     */
    undo?: UndoPreviewResponse;
    /**
     * 
     * @type {ReengagePreviewResponse}
     * @memberof TransactionResponse
     */
    reengage?: ReengagePreviewResponse;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    buyerEmailRecipient?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    helpscoutLink?: string;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    counterOffersCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    documentCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TransactionResponse
     */
    noteCount?: number;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    createdByName?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    reviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    reviewedById?: string;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    customerVisibleAt?: Date;
    /**
     * 
     * @type {ClientDecision}
     * @memberof TransactionResponse
     */
    clientDecision?: ClientDecision;
    /**
     * 
     * @type {boolean}
     * @memberof TransactionResponse
     */
    clientDecisionCurrent?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TransactionResponse
     */
    clientDecisionAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    clientDecisionNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    clientDecisionReason?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    clientDecisionChannel?: string;
    /**
     * 
     * @type {string}
     * @memberof TransactionResponse
     */
    clientDecisionTermsId?: string;
    /**
     * 
     * @type {TransactionTermsResponse}
     * @memberof TransactionResponse
     */
    proposedTerms?: TransactionTermsResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof TransactionResponse
     */
    proposedTermsMovedFields?: Array<string>;
    /**
     * 
     * @type {Array<TransactionTermsResponse>}
     * @memberof TransactionResponse
     */
    terms?: Array<TransactionTermsResponse>;
    /**
     * 
     * @type {TransactionEmailOutcomeResponse}
     * @memberof TransactionResponse
     */
    emailOutcome?: TransactionEmailOutcomeResponse;
}

/**
 * Check if a given object implements the TransactionResponse interface.
 */
export function instanceOfTransactionResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "isBackup" in value;

    return isInstance;
}

export function TransactionResponseFromJSON(json: any): TransactionResponse {
    return TransactionResponseFromJSONTyped(json, false);
}

export function TransactionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TransactionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dispositionId': !exists(json, 'disposition_id') ? undefined : json['disposition_id'],
        'acquisitionId': !exists(json, 'acquisition_id') ? undefined : json['acquisition_id'],
        'side': json['side'],
        'type': json['type'],
        'status': json['status'],
        'metaLabel': !exists(json, 'meta_label') ? undefined : json['meta_label'],
        'turn': !exists(json, 'turn') ? undefined : TransactionTurnFromJSON(json['turn']),
        'turnLabel': !exists(json, 'turn_label') ? undefined : json['turn_label'],
        'buyerFullName': !exists(json, 'buyer_full_name') ? undefined : json['buyer_full_name'],
        'buyerEmail': !exists(json, 'buyer_email') ? undefined : json['buyer_email'],
        'buyerPhone': !exists(json, 'buyer_phone') ? undefined : json['buyer_phone'],
        'buyerRepresentation': !exists(json, 'buyer_representation') ? undefined : json['buyer_representation'],
        'buyerAgentFullName': !exists(json, 'buyer_agent_full_name') ? undefined : json['buyer_agent_full_name'],
        'buyerAgentEmail': !exists(json, 'buyer_agent_email') ? undefined : json['buyer_agent_email'],
        'buyerAgentPhone': !exists(json, 'buyer_agent_phone') ? undefined : json['buyer_agent_phone'],
        'buyerAgentBrokerage': !exists(json, 'buyer_agent_brokerage') ? undefined : json['buyer_agent_brokerage'],
        'buyerAgentLicenseNumber': !exists(json, 'buyer_agent_license_number') ? undefined : json['buyer_agent_license_number'],
        'receivedAt': !exists(json, 'received_at') ? undefined : (new Date(json['received_at'])),
        'offerSource': !exists(json, 'offer_source') ? undefined : json['offer_source'],
        'statusReason': !exists(json, 'status_reason') ? undefined : json['status_reason'],
        'isBackup': json['is_backup'],
        'currentTerms': !exists(json, 'current_terms') ? undefined : TransactionTermsResponseFromJSON(json['current_terms']),
        'originalTerms': !exists(json, 'original_terms') ? undefined : TransactionTermsResponseFromJSON(json['original_terms']),
        'signatureState': !exists(json, 'signature_state') ? undefined : json['signature_state'],
        'finalWalkthroughScheduledAt': !exists(json, 'final_walkthrough_scheduled_at') ? undefined : (new Date(json['final_walkthrough_scheduled_at'])),
        'wireInstructionsReceivedAt': !exists(json, 'wire_instructions_received_at') ? undefined : (new Date(json['wire_instructions_received_at'])),
        'titleClearanceStatus': !exists(json, 'title_clearance_status') ? undefined : TitleClearanceStatusFromJSON(json['title_clearance_status']),
        'titleClearedAt': !exists(json, 'title_cleared_at') ? undefined : (new Date(json['title_cleared_at'])),
        'closingRepairsCompleted': !exists(json, 'closing_repairs_completed') ? undefined : json['closing_repairs_completed'],
        'hazardInsuranceReceivedAt': !exists(json, 'hazard_insurance_received_at') ? undefined : (new Date(json['hazard_insurance_received_at'])),
        'pinnedAt': !exists(json, 'pinned_at') ? undefined : (new Date(json['pinned_at'])),
        'isRecommended': !exists(json, 'is_recommended') ? undefined : json['is_recommended'],
        'duplicateOfTransactionId': !exists(json, 'duplicate_of_transaction_id') ? undefined : json['duplicate_of_transaction_id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'updatedAt': !exists(json, 'updated_at') ? undefined : (new Date(json['updated_at'])),
        'addressStr': !exists(json, 'address_str') ? undefined : json['address_str'],
        'partnerEntityName': !exists(json, 'partner_entity_name') ? undefined : json['partner_entity_name'],
        'noteForSeller': !exists(json, 'note_for_seller') ? undefined : json['note_for_seller'],
        'additionalComments': !exists(json, 'additional_comments') ? undefined : json['additional_comments'],
        'reengagedAt': !exists(json, 'reengaged_at') ? undefined : (new Date(json['reengaged_at'])),
        'acceptedAt': !exists(json, 'accepted_at') ? undefined : (new Date(json['accepted_at'])),
        'actualCloseDate': !exists(json, 'actual_close_date') ? undefined : json['actual_close_date'],
        'canTerminate': !exists(json, 'can_terminate') ? undefined : json['can_terminate'],
        'canEditBindingDate': !exists(json, 'can_edit_binding_date') ? undefined : json['can_edit_binding_date'],
        'canCounter': !exists(json, 'can_counter') ? undefined : json['can_counter'],
        'canWithdraw': !exists(json, 'can_withdraw') ? undefined : json['can_withdraw'],
        'undo': !exists(json, 'undo') ? undefined : UndoPreviewResponseFromJSON(json['undo']),
        'reengage': !exists(json, 'reengage') ? undefined : ReengagePreviewResponseFromJSON(json['reengage']),
        'buyerEmailRecipient': !exists(json, 'buyer_email_recipient') ? undefined : json['buyer_email_recipient'],
        'helpscoutLink': !exists(json, 'helpscout_link') ? undefined : json['helpscout_link'],
        'counterOffersCount': !exists(json, 'counter_offers_count') ? undefined : json['counter_offers_count'],
        'documentCount': !exists(json, 'document_count') ? undefined : json['document_count'],
        'noteCount': !exists(json, 'note_count') ? undefined : json['note_count'],
        'createdByName': !exists(json, 'created_by_name') ? undefined : json['created_by_name'],
        'reviewedAt': !exists(json, 'reviewed_at') ? undefined : (new Date(json['reviewed_at'])),
        'reviewedById': !exists(json, 'reviewed_by_id') ? undefined : json['reviewed_by_id'],
        'customerVisibleAt': !exists(json, 'customer_visible_at') ? undefined : (new Date(json['customer_visible_at'])),
        'clientDecision': !exists(json, 'client_decision') ? undefined : ClientDecisionFromJSON(json['client_decision']),
        'clientDecisionCurrent': !exists(json, 'client_decision_current') ? undefined : json['client_decision_current'],
        'clientDecisionAt': !exists(json, 'client_decision_at') ? undefined : (new Date(json['client_decision_at'])),
        'clientDecisionNotes': !exists(json, 'client_decision_notes') ? undefined : json['client_decision_notes'],
        'clientDecisionReason': !exists(json, 'client_decision_reason') ? undefined : json['client_decision_reason'],
        'clientDecisionChannel': !exists(json, 'client_decision_channel') ? undefined : json['client_decision_channel'],
        'clientDecisionTermsId': !exists(json, 'client_decision_terms_id') ? undefined : json['client_decision_terms_id'],
        'proposedTerms': !exists(json, 'proposed_terms') ? undefined : TransactionTermsResponseFromJSON(json['proposed_terms']),
        'proposedTermsMovedFields': !exists(json, 'proposed_terms_moved_fields') ? undefined : json['proposed_terms_moved_fields'],
        'terms': !exists(json, 'terms') ? undefined : ((json['terms'] as Array<any>).map(TransactionTermsResponseFromJSON)),
        'emailOutcome': !exists(json, 'email_outcome') ? undefined : TransactionEmailOutcomeResponseFromJSON(json['email_outcome']),
    };
}

export function TransactionResponseToJSON(value?: TransactionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disposition_id': value.dispositionId,
        'acquisition_id': value.acquisitionId,
        'side': value.side,
        'type': value.type,
        'status': value.status,
        'meta_label': value.metaLabel,
        'turn': TransactionTurnToJSON(value.turn),
        'turn_label': value.turnLabel,
        'buyer_full_name': value.buyerFullName,
        'buyer_email': value.buyerEmail,
        'buyer_phone': value.buyerPhone,
        'buyer_representation': value.buyerRepresentation,
        'buyer_agent_full_name': value.buyerAgentFullName,
        'buyer_agent_email': value.buyerAgentEmail,
        'buyer_agent_phone': value.buyerAgentPhone,
        'buyer_agent_brokerage': value.buyerAgentBrokerage,
        'buyer_agent_license_number': value.buyerAgentLicenseNumber,
        'received_at': value.receivedAt === undefined ? undefined : (value.receivedAt.toISOString()),
        'offer_source': value.offerSource,
        'status_reason': value.statusReason,
        'is_backup': value.isBackup,
        'current_terms': TransactionTermsResponseToJSON(value.currentTerms),
        'original_terms': TransactionTermsResponseToJSON(value.originalTerms),
        'signature_state': value.signatureState,
        'final_walkthrough_scheduled_at': value.finalWalkthroughScheduledAt === undefined ? undefined : (value.finalWalkthroughScheduledAt.toISOString()),
        'wire_instructions_received_at': value.wireInstructionsReceivedAt === undefined ? undefined : (value.wireInstructionsReceivedAt.toISOString()),
        'title_clearance_status': TitleClearanceStatusToJSON(value.titleClearanceStatus),
        'title_cleared_at': value.titleClearedAt === undefined ? undefined : (value.titleClearedAt.toISOString()),
        'closing_repairs_completed': value.closingRepairsCompleted,
        'hazard_insurance_received_at': value.hazardInsuranceReceivedAt === undefined ? undefined : (value.hazardInsuranceReceivedAt.toISOString()),
        'pinned_at': value.pinnedAt === undefined ? undefined : (value.pinnedAt.toISOString()),
        'is_recommended': value.isRecommended,
        'duplicate_of_transaction_id': value.duplicateOfTransactionId,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updated_at': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'address_str': value.addressStr,
        'partner_entity_name': value.partnerEntityName,
        'note_for_seller': value.noteForSeller,
        'additional_comments': value.additionalComments,
        'reengaged_at': value.reengagedAt === undefined ? undefined : (value.reengagedAt.toISOString()),
        'accepted_at': value.acceptedAt === undefined ? undefined : (value.acceptedAt.toISOString()),
        'actual_close_date': value.actualCloseDate,
        'can_terminate': value.canTerminate,
        'can_edit_binding_date': value.canEditBindingDate,
        'can_counter': value.canCounter,
        'can_withdraw': value.canWithdraw,
        'undo': UndoPreviewResponseToJSON(value.undo),
        'reengage': ReengagePreviewResponseToJSON(value.reengage),
        'buyer_email_recipient': value.buyerEmailRecipient,
        'helpscout_link': value.helpscoutLink,
        'counter_offers_count': value.counterOffersCount,
        'document_count': value.documentCount,
        'note_count': value.noteCount,
        'created_by_name': value.createdByName,
        'reviewed_at': value.reviewedAt === undefined ? undefined : (value.reviewedAt.toISOString()),
        'reviewed_by_id': value.reviewedById,
        'customer_visible_at': value.customerVisibleAt === undefined ? undefined : (value.customerVisibleAt.toISOString()),
        'client_decision': ClientDecisionToJSON(value.clientDecision),
        'client_decision_current': value.clientDecisionCurrent,
        'client_decision_at': value.clientDecisionAt === undefined ? undefined : (value.clientDecisionAt.toISOString()),
        'client_decision_notes': value.clientDecisionNotes,
        'client_decision_reason': value.clientDecisionReason,
        'client_decision_channel': value.clientDecisionChannel,
        'client_decision_terms_id': value.clientDecisionTermsId,
        'proposed_terms': TransactionTermsResponseToJSON(value.proposedTerms),
        'proposed_terms_moved_fields': value.proposedTermsMovedFields,
        'terms': value.terms === undefined ? undefined : ((value.terms as Array<any>).map(TransactionTermsResponseToJSON)),
        'email_outcome': TransactionEmailOutcomeResponseToJSON(value.emailOutcome),
    };
}

